import React from 'react';
import css from './FileUpload.module.css';

export const IconError = () => (
  <svg
    className={css.iconError}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="none"
  >
    <path
      d="M9.99999 12.5001C10.4602 12.5001 10.8333 12.8732 10.8333 13.3334C10.8333 13.7937 10.4602 14.1667 9.99999 14.1667C9.53975 14.1667 9.16666 13.7937 9.16666 13.3334C9.16666 12.8732 9.53975 12.5001 9.99999 12.5001Z"
      fill="currentColor"
    />
    <path
      d="M9.99999 5.83342C10.4602 5.83342 10.8333 6.20651 10.8333 6.66675V10.4167C10.8333 10.877 10.4602 11.2501 9.99999 11.2501C9.53975 11.2501 9.16666 10.877 9.16666 10.4167V6.66675C9.16666 6.20651 9.53975 5.83342 9.99999 5.83342Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99999 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 9.99999 18.3334C5.39762 18.3334 1.66666 14.6025 1.66666 10.0001C1.66666 5.39771 5.39762 1.66675 9.99999 1.66675ZM9.99999 3.33341C6.31809 3.33341 3.33332 6.31818 3.33332 10.0001C3.33332 13.682 6.31809 16.6667 9.99999 16.6667C13.6819 16.6667 16.6667 13.682 16.6667 10.0001C16.6667 6.31818 13.6819 3.33341 9.99999 3.33341Z"
      fill="currentColor"
    />
  </svg>
);
